import { takeLatest, put, call, select } from 'redux-saga/effects';
import { COPY_DAY_BOOKING_SAGA } from "../sagaTypes";
import { loaderAction, calendarAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getWeekBookingSagaAction } from "../sagaActions";
import { CALENDAR_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/copy_day_booking`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerCopyDayBooking(args) {
    const user = yield select(state => state.user);
    const currentEstablishment = yield select(state => state.currentEstablishment);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('date', args.data.date);
        formData.append('copy_days', args.data.copy_days);
        formData.append('establishment', currentEstablishment);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Обновляем записи
            yield put(getWeekBookingSagaAction({
                establishment: currentEstablishment,
                date: args.data.date
            }));

            // Закрываем календарь
            yield put(calendarAction(CALENDAR_INITIAL));
            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherCopyDayBooking() {
    yield takeLatest(COPY_DAY_BOOKING_SAGA, workerCopyDayBooking);
}